import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import { generateInputField } from "helpers/form_helper_old";
import { modeDetail } from "pages/GeneralInfo/Customer/utils";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { createAccountBank } from "store/general-info/customer/actions";
import * as yup from "yup";

const CreateAccountBankModal = props => {
  const { isOpenModal, dataDetail, toggleModal, mode } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["customer"]);
  const { addToast } = useToasts();

  const customerInvoice = useSelector(state => state.customerInvoice);
  const { loading, data, error } = customerInvoice.createAccountBankData;

  const schema = yup.object().shape({
    account_number: yup
      .string()
      .required(t("form.validate.required", { title: t("form.stknhang") })),
    account_name: yup
      .string()
      .required(t("form.validate.required", { title: t("form.ttknhang") })),
    bank_name: yup
      .string()
      .required(t("form.validate.select", { title: t("form.tnhang") })),
    branch_name: yup
      .string()
      .required(t("form.validate.select", { title: t("form.chinhanh") })),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (isOpenModal) {
      reset();
    }
  }, [isOpenModal]);

  const onSubmit = values => {
    const data = {
      ...values,
    };
    switch (mode) {
      case modeDetail.CREATE:
        dispatch(createAccountBank(data));
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Modal
        size="lg"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            {mode === modeDetail.CREATE && `Thêm tải khoản ngân hàng`}
          </ModalHeader>
          {loading ? (
            <ModalBody>
              <LoadingFormNormal
                countInput="3"
                countButton="1"
                formClass="row-cols-1 row-cols-md-2"
                buttonClass="justify-content-end"
                buttonColClass="col-3"
              />
            </ModalBody>
          ) : (
            <React.Fragment>
              <ModalBody>
                <Row className="row-cols-1 row-cols-lg-1">
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.stknhang"),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        "account_number",
                        t("placeholder.enter", {
                          title: t("form.stknhang"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.ttknhang"),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        "account_name",
                        t("placeholder.enter", {
                          title: t("form.ttknhang"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.tnhang"),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        "bank_name",
                        t("placeholder.enter", {
                          title: t("form.tnhang"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField(
                        t("form.chinhanh"),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        "branch_name",
                        t("placeholder.enter", {
                          title: t("form.chinhanh"),
                        }),
                        register,
                        mode === modeDetail.VIEW || loading
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                {mode !== modeDetail.VIEW && (
                  <Row className="justify-content-end">
                    <Col className="col-auto">
                      <Button
                        color="primary"
                        className="btn-label"
                        type="button"
                        onClick={() => {
                          handleSubmit(onSubmit)();
                        }}
                        disabled={loading}
                      >
                        <i className="bx bx-save label-icon"></i>
                        {mode === modeDetail.CREATE && t("form.save")}
                        {mode === modeDetail.EDIT && t("form.update")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </ModalFooter>
            </React.Fragment>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

CreateAccountBankModal.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
  mode: PropTypes.string,
};

CreateAccountBankModal.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
};

export default CreateAccountBankModal;
